(() => {
  if (window.Shopify?.designMode) return;
  const desktop = window.matchMedia('(min-width: 1024px)');
  const rootSelector = '.site-navigation .navmenu-id-brands > details';
  const brandSelector = '.navmenu-meganav-sidenav__item > details';
  const root = () => document.querySelector(rootSelector);

  function expanded(details, value) {
    details.open = value;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(value));
  }

  function closeChildren(menu) {
    menu?.querySelectorAll(brandSelector).forEach(details => expanded(details, false));
  }

  function place(details) {
    const box = details.closest('.navmenu-meganav-sidenav__items');
    const summary = details.querySelector(':scope > summary');
    const panel = details.querySelector('.navmenu-depth-3');
    if (!box || !summary || !panel) return;
    const bounds = box.getBoundingClientRect();
    const row = summary.getBoundingClientRect();
    const width = 264;
    let x = row.right - bounds.left;
    if (row.right + width > Math.min(innerWidth - 12, bounds.right)) x = row.left - bounds.left - width;
    const bottom = innerHeight - (document.getElementById('PBarNextFrame') ? 80 : 16);
    const maxHeight = Math.max(120, bottom - bounds.top);
    details.style.setProperty('--lnw-panel-x', Math.max(0, x) + 'px');
    details.style.setProperty('--lnw-panel-height', maxHeight + 'px');
    details.style.setProperty('--lnw-panel-y', Math.max(0, Math.min(row.top - bounds.top, bottom - bounds.top - Math.min(panel.scrollHeight, maxHeight))) + 'px');
  }

  function toggleBrand(details) {
    const menu = root();
    const next = !details.open;
    closeChildren(menu);
    expanded(details, next);
    if (next) place(details);
  }

  function closeMenu() {
    const menu = root();
    closeChildren(menu);
    if (menu) expanded(menu, false);
  }

  window.addEventListener('click', event => {
    if (!desktop.matches) return;
    const menu = root();
    if (!menu) return;
    const summary = event.target.closest('summary');
    if (summary === menu.querySelector(':scope > summary')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const next = !menu.open;
      closeChildren(menu);
      expanded(menu, next);
    } else if (summary?.parentElement.matches(brandSelector) && menu.contains(summary) && !event.target.closest('a')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleBrand(summary.parentElement);
    } else if (!menu.contains(event.target)) {
      closeMenu();
    }
  }, true);

  window.addEventListener('focusin', event => {
    const menu = root();
    if (desktop.matches && menu && !menu.contains(event.target)) closeMenu();
  });

  window.addEventListener('keydown', event => {
    if (!desktop.matches) return;
    const menu = root();
    if (!menu) return;
    if (event.key === 'Escape' && menu.open) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMenu();
      menu.querySelector(':scope > summary')?.focus({ preventScroll: true });
    } else if ((event.key === 'Enter' || event.key === ' ') && event.target.matches(rootSelector + ' ' + brandSelector + ' > summary')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleBrand(event.target.parentElement);
    }
  }, true);
  desktop.addEventListener('change', closeMenu);
})();
